import { SectionOneFormState } from '../models/section-one-form-state';
import { SectionOneForm } from '../../validators/section-one.schema';
import { SectionOneSteps } from '../models/section-one-steps';

export class SectionOne {
  formFields: Partial<SectionOneForm>;
  status: SectionOneFormState;
  i9formId: string;
  currentStep: SectionOneSteps;
  isRemoteLocation?: boolean;
  referenceNumber?: string;
  /** Amendment resume only: a remote completer is already named (VTK-2182). */
  remoteCompleterNamed?: boolean;
  /** Amendment resume only: the re-sign returns an already-signed Section 2 to review (VTK-2182). */
  signedSection2OnFile?: boolean;
  /** Amendment resume only: the location's name, for a site no longer active (VTK-2184). */
  locationName?: string | null;

  constructor(
    formFields: Partial<SectionOneForm>,
    status: SectionOneFormState,
    i9formId: string,
    currentStep: SectionOneSteps
  ) {
    this.formFields = formFields;
    this.status = status;
    this.i9formId = i9formId;
    this.currentStep = currentStep;
  }
}

export default SectionOne;
